export const zh = {
  loading: "加载中",
  common: {
    confirmTitle: "确认操作",
    cancel: "取消",
    confirm: "确认",
  },
  page: {
    title: "パズル⭐︎セカ | Puzzle × SEKAI",
    description:
      "少年少女们忽然发现，熟悉的「世界」变成了由多彩方块堆叠的消消乐世界？！初音未来、天马咲希、宵崎奏等角色从天而降，把同组合的小伙伴们连成一片就能消除得分！非商业粉丝作品，和SEGA、Colorful Palette以及Crypton Future Media没有任何关系哦☆",
    keywords:
      "パズル⭐︎セカ,Puzzle SEKAI,烤罗斯方块,啤酒烧烤,世界计划,缤纷舞台,Project SEKAI,PJSK,プロセカ,初音未来,ミク,Miku,Vocaloid,虚拟歌手,消消乐,方块消除,下落方块,Puyo,组合消除,同人游戏,浏览器游戏,无尽模式,计时挑战,每日挑战,Leo/need,MORE MORE JUMP,Vivid BAD SQUAD,Wonderlands×Showtime,25時、ナイトコードで。,25时,Nightcord,NeneRobo,Mikudayo,高分,PixiJS",
  },
  welcome: {
    title: "パズル⭐︎セカ",
    subtitle: "～ Puzzle × SEKAI ～",
    desc: "把同组合的成员连成一片，消除得分！<br>（字面意义上的团建）",
    click: "点击继续",
    disclaimer: "セカイは、パズルになった。 · By 1806",
    howto: "怎么玩",
    howtoClose: "关闭",
  },
  menu: {
    title: "パズル⭐︎セカ",
    subtitle: "Puzzle × SEKAI",
    endless: "无尽模式",
    timeAttack: "限时挑战",
    daily: "每日挑战",
    settings: "设置",
    controls: "操作说明",
    about: "关于",
    highScore: {
      endless: "无尽模式",
      timeAttack: "限时挑战",
      daily: "每日挑战",
      tapToSwitch: "点击切换纪录",
    },
  },
  leaderboard: {
    button: "排行榜",
    title: "每日排行榜",
    loading: "正在加载排行榜...",
    empty: "今天还没有成绩。",
    anonymous: "匿名玩家",
    signIn: "登录后可查看排行榜。",
    failed: "排行榜加载失败。",
    submitting: "正在上传成绩...",
    myRank: "排名：第 {rank} / {total} 名",
    notRanked: "暂无有效成绩。",
    unavailable: "排行榜暂不可用。",
    bilibiliBest: "B服云端最高分",
    serverOfficial: "官服",
    serverBilibili: "B服",
    mode: {
      daily: "每日挑战",
      endless: "无尽模式",
      timeAttack: "计时模式",
    },
  },
  display: {
    rotateLandscape: "请把设备横过来再开始游戏",
  },
  a11y: {
    matchStart: "对局开始。模式：{mode}。",
    score: "分数 {score}",
    scoreCombo: "分数 {score}，连击 {combo}",
    timeLow: "剩余时间 {time}",
    paused: "已暂停",
    resumed: "已继续",
    gameOver: "游戏结束。最终分数 {score}。",
    menu: "主菜单",
    mainMenu: "主菜单",
  },
  pause: {
    title: "暂停",
    resume: "继续",
    restart: "重来",
    menu: "返回主菜单",
    button: "暂停",
  },
  gameOver: {
    title: "游戏结束",
    mode: "模式",
    score: "分数",
    highScore: "最高分",
    maxCombo: "COMBO",
    multiplier: "倍率",
    difficulty: "难度",
    groups: "各组合消除",
    newRecord: "新纪录！",
    share: "分享卡片",
    shareFailed: "分享失败",
    shareText: "我在パズル⭐︎セカ得了 {score} 分！",
    shareTextNamed: "{name} 在パズル⭐︎セカ得了 {score} 分！",
    restart: "再来一局",
    menu: "回到主界面",
  },
  replay: {
    watchAgain: "再看一遍",
  },
  dan: {
    none: "无段位",
    beginner: "初级",
    intermediate: "中级",
    advanced: "高级",
    expert: "达人",
    kaiden: "皆传",
    hiden: "秘传",
    shinKaiden: "真·皆传",
    shinHiden: "真·秘传",
    gokuden: "极传",
    promoted: "段位上升！",
    rating: "段位点 {total}",
  },
  auth: {
    login: "登录 SEKAI",
    loginShort: "登录",
    loginWithSekaiPass: "用 SEKAI Pass 登录",
    loggingIn: "登录中…",
    logout: "退出登录",
    syncing: "同步中…",
    syncOk: "已同步",
    syncFailed: "同步失败",
    loginFailed: "登录失败，请稍后重试。",
    notConfigured: "登录未设置（缺少 client_id）",
    loggedInAs: "{name}",
  },
  settings: {
    title: "设置",
    speed: {
      label: "速度等级",
      slow: "慢速",
      normal: "普通",
      fast: "快速",
      faster: "极速",
      hell: "地狱",
    },
    ta: {
      label: "限时挑战时长",
      duration: "{seconds}秒",
    },
    groups: {
      label: "出现组合（最少3个）",
    },
    item: {
      label: "道具掉落概率",
      none: "无",
      tooltip: "得分倍率 ×{factor}",
    },
    orientation: {
      label: "下落姿态",
      inverted: "头朝下",
      upright: "头朝上",
      invertedHelp: "角色倒置下落（默认）。辨认稍难，得分倍率标准。",
      uprightHelp: "角色正向下落。更容易辨认，得分倍率略低。",
    },
    fun: {
      label: "娱乐模式（开启任一即生效）",
      help: "选择标签查看说明",
      itemLinked: "（道具率联动）",
    },
    difficulty: {
      label: "难度 / 得分倍率",
      entertainment: "娱乐",
      info: "ⓘ 详情",
      breakdownTitle: "得分倍率明细",
      total: "合计",
      diffLine: "难度 {difficulty}（速度{speed} · {groups}个组合）",
      itemLine: "道具掉落 {rate}",
      orientLine: "下落姿态 · {orient}",
      funLineItemLinked: "{name}（道具率联动）",
      starHint:
        "难度名（Easy～Append）看下落速度和出场组合数。道具、朝向、娱乐模式只会改得分倍率，不会改难度名。评级与段位看你的操作表现，调低倍率也不会让评级吃亏。",
    },
    lang: {
      label: "语言 / Language",
    },
    audio: {
      label: "音量",
      bgm: "BGM",
      sfx: "音效",
      voice: "语音",
    },
    performance: {
      label: "性能",
      normal: "标准",
      low: "低性能",
      normalHelp: "全分辨率渲染（最清晰）。布局与操作不变。",
      lowHelp:
        "渲染缓冲减半（约 1/4 像素）。画面会略糊，但布局、判定和操作完全不变。",
    },
    display: {
      label: "显示模式",
      windowed: "窗口",
      borderless: "无边框",
      fullscreen: "全屏",
      windowedHelp: "窗口模式，不会自动全屏。",
      windowedWebHelp: "正常网页显示，不会自动全屏。",
      borderlessHelp: "去掉标题栏铺满屏幕（仅桌面客户端）。",
      fullscreenHelp: "全屏。开始游戏时自动进入。",
    },
    touchControl: {
      label: "触控操作",
      stick: "摇杆",
      gesture: "手势",
      drag: "跟指",
      zones: "分区",
      stickHelp: "默认。按下出现摇杆，拨动摇杆移动方块，中心长按蓄力硬降。",
      gestureHelp:
        "经典操作。左右滑动移动，按住不放加速下落，甩动硬降，轻点旋转。",
      dragHelp: "手指拖多远，方块就移动多远。适合高速操作。",
      zonesHelp: "按住左右边缘移动，点击中间旋转，按住底部加速下落。",
      nextPieceHint: "下一块起生效",
    },
    replays: {
      label: "回放",
      watch: "查看回放",
      empty: "还没有可查看的回放。",
      help: "本地保存最近 20 局（不含 truePhysics）。",
    },
    data: {
      label: "数据 / 缓存",
      clearCache: "清除缓存",
      clearData: "清除数据",
      clearCacheConfirm:
        "清除已下载的离线缓存（音频、字体等）？设置与高分不受影响。",
      clearDataConfirm:
        "清除本地设置、语言、全部高分记录与回放？此操作不可撤销。",
      clearCacheDone: "缓存已清除",
      clearDataDone: "数据已清除，页面将刷新",
      clearFailed: "操作失败，请稍后重试",
      working: "处理中…",
    },
  },
  difficulty: {
    1: "Easy",
    2: "Normal",
    3: "Hard",
    4: "Expert",
    5: "Master",
    6: "Re:Master",
    7: "Append",
  },
  fun: {
    mikudayo: {
      name: "「Mikudayo！」",
      subtitle: "「世界」的造访者",
      description:
        "Mikudayo将作为特制的 2×2 巨型方块下落。该方块在判定时可视为任意「Miku」组合的一员——是的，不管你愿不愿意，她都能混进任何队伍。同时，当她被消除时，能将与之相邻的不同组合连带一起消除（波及范围极广，请做好心理准备）。",
    },
    kanadeSlow: {
      name: "奏明天空",
      subtitle: "微弱的呼吸与消逝的引力",
      description:
        "「奏」在下落期间，自身的下落速度固定降低 50%。\n当「奏」着地后，该减速效果将转化为「余韵」状态传递给后续方块，使整体下落速度随时间逐渐恢复。若「奏」在场上被消除，该减速恢复效果将立即解除。\n\n「只要音符还没有完全止息……」",
    },
    wonderBlast: {
      name: "奇迹爆破",
      subtitle: "It's Showtime！",
      description:
        "当「类」与「NeneRobo」在同一次消除中且彼此相邻时，将引发舞台大爆炸，随机炸飞场上其他方块。没错，这就是沈大雷的作风——能用爆炸解决的事情为什么要慢慢消？\n炸飞数量约为「2 + 2 × 本次消除中类与 NeneRobo 的精灵数」，上限 12 且不超过半场。爆炸按炸掉的格子数加分（一次计分）。\n\n「接下来，就是最精彩的 Showtime 了！NeneRobo，出力最大化——！」",
    },
    shizukuSwap: {
      name: "指南针的恶作剧",
      subtitle: "「诶？这里是哪里……？」",
      description:
        "消除「雫」后将触发「异变」：左右移动与左右旋转全部反转，且会一直持续，直到解除。\n若消除时场上仍有「志步」，则不会触发（妹妹的存在就是最好的指南针）；异变期间若「志步」着地（或场上再次存在志步），异变立即强制解除。\n\n「哎呀……方向原来是反的吗？总觉得，有点绕远路了呢……」",
    },
    itemAllergy: {
      name: "橙色警报！",
      subtitle: "绝对不可直视的「那个东西」",
      description:
        "当落下的「绘名」或「彰人」与场上的「胡萝卜」接触时，将引发「本能排斥」，使角色方块瞬间消失。姐弟俩对胡萝卜的厌恶终于上升到了游戏机制层面，这大概就是所谓的「设定即玩法」吧。\n在操作阶段，玩家无法主动将这两位角色移动至会引发排斥的列；若因重力下落至相邻格子，将重新触发排斥检查。注意：「胡萝卜」本身不会因该效果消失（胡萝卜：？）。\n\n「笨蛋彰人！快把那个橙色的东西拿开！」「……这句话原封不动地还给你，绘名。」",
    },
    mizukiShift: {
      name: "薯条重力场",
      subtitle: "顺着香味，捕获成功♪",
      description:
        "当场上存在「薯条」时，将锁定所有下落着地后必定会与薯条相邻的列。此时「瑞希」只能在这些「触发列」之间进行跳跃移动。若场上没有可接触的列，则移动恢复正常。\n此外，当「薯条」着地时，距离其最近的「瑞希」会被强制吸引，自动位移至该「薯条」的正上方（薯条的引力比牛顿发现的那个强多了）。\n若「瑞希」与「薯条」处于相邻格子，会立刻把薯条吃掉，并获得额外分数。消耗品，吃完就没了，请珍惜每一根薯条。\n\n「只要顺着薯条的香味看过去，就一定能捕捉到那个悄悄凑过来的身影吧♪」",
    },
    emuShrink: {
      name: "凤的生存法则",
      subtitle: "「噫——！要缩起来才行……！」",
      description:
        "当「笑梦」与「真冬」处于相邻格子时，「笑梦」将受到惊吓并坍缩为 1×1 的单格大小。「Wonderlands×Showtime」的开朗担当在「Nightcord」的阴郁担当面前选择缩小自己——某种意义上这确实是最合理的生存策略。坍缩后将远离「真冬」。随后全场方块将重新进行重力与物理下落判定。\n\n「总觉得……在朝比奈学姐身边的时候，如果不悄悄地缩起来，就会有非常可怕的事情发生……！」",
    },
    cantilever: {
      name: "悬臂翻转",
      subtitle: "一边撑着，一边就会翻下去",
      description:
        "简化物理引擎之一。重力落稳后：若横向跨多列的方块（含横放 2 格块、2×2 的 NeneRobo / Mikudayo）底部仅一侧有支撑、另一侧悬空，会绕支撑边沿朝悬空侧刚体翻转 90°，再重新受重力落下。竖放的 2 格块不会触发。\n只靠该结构支撑的上方方块会一并被翘起旋转；若上方另有外部支撑把结构钉住，则不翻转。翻转后会立刻重跑接触类效果（如笑梦坍缩、消除判定等）。\n与「真实物理」互斥，只能二选一。\n\n「支点……好像不太稳啊？」",
    },
    truePhysics: {
      name: "真实物理",
      subtitle: "重心、力矩，然后一塌糊涂",
      description:
        "完整刚体物理引擎（Rapier2D）。方块按质量、摩擦与力矩真实下落堆叠，允许结构倾倒、滑动与连锁崩塌；团消除改为接触近距判定，不再吸附格子。开启前请做好心理准备：你的精心布局可能会在一瞬间变成一塌糊涂。\n首次开启时会下载物理引擎包。与「悬臂翻转」互斥。\n\n「……牛顿先生，请对这个 SEKAI 温柔一点。」",
    },
  },
  inGame: {
    combo: "连击",
    timeLeft: "剩余时间",
  },
  hsTags: {
    record: "纪录",
    entertainment: "娱乐",
    entCompact: "FUN",
  },
  controls: {
    title: "操作说明",
    keyboard: "键盘",
    mobile: "手机",
    close: "关闭",
    moveLeftRight: "← → 左右移动",
    rotateClockwise: "↑ / X 顺时针旋转",
    rotateCounter: "Ctrl / Z 逆时针旋转",
    softDrop: "↓ 加速下落",
    hardDrop: "Space 直接落到底部",
    restart: "R 重新开始",
    pause: "Esc / P 暂停（也可点左上角按钮）",
    swipeMove: "按下显示摇杆 · 拨动摇杆移动",
    tapRotate: "短点左/右半屏旋转",
    swipeHardDrop: "中心长按蓄力硬降",
    pressSoftDrop: "摇杆下推加速下落",
    easterEgg: "笑梦 / NeneRobo 下落时 · Shift+↑ 或手机上甩 微抬一格",
    modeStickMove: "按下显示摇杆 · 拨动摇杆移动",
    modeStickRotate: "短点左/右半屏旋转",
    modeStickSoft: "摇杆下推加速下落",
    modeStickHard: "中心长按蓄力硬降 · 也可下甩",
    modeGestureMove: "左右滑动移动一格",
    modeGestureRotate: "短点左/右半屏旋转",
    modeGestureSoft: "按住不放加速下落",
    modeGestureHard: "下甩硬降 · 上甩微抬",
    modeDragMove: "拖动手指移动方块",
    modeDragRotate: "短点左/右半屏旋转",
    modeDragSoft: "向下拖住加速下落",
    modeDragHard: "下甩硬降 · 上甩微抬",
    modeZonesMove: "按住左/右边缘移动",
    modeZonesRotate: "点击中间旋转",
    modeZonesSoft: "按住底部加速下落",
    modeZonesHard: "中间长按蓄力硬降 · 也可下甩",
  },
  noscript: {
    title: "浏览器不支持",
    message:
      "如果你看到空白页面，可能是浏览器不支持 WebGL。<br/>请尝试使用 Chrome 等现代浏览器。",
  },
  footer: {
    original: "原作",
    inspiration: "灵感",
    thisProject: "本作",
    author: "作者",
    support: "支持",
    feedback: "反馈",
  },
  about: {
    title: "关于",
    version: "版本",
    afdian: "爱发电",
    reportIssue: "提交 Issue",
    disclaimerTitle: "免责声明",
    disclaimerP1:
      "本项目（パズル⭐︎セカ / puzzle-sekai）为非官方粉丝作品（Fan Art），与 SEGA、Colorful Palette 或 Crypton Future Media 无任何关联。",
    disclaimerP2:
      "本项目中使用的所有游戏素材（包括但不限于视频、音频、图像、角色设计、剧本等）的版权均归 <strong>© SEGA</strong>、<strong>© Colorful Palette Inc.</strong> 及 <strong>© Crypton Future Media, INC.</strong> 所有。",
    disclaimerP3:
      "本项目仅供学习、研究及个人欣赏使用，<strong>严禁用于任何形式的商业用途或营利活动</strong>。开发者不对因使用本项目而产生的任何直接或间接损失承担责任。",
    disclaimerP4:
      "如权利方认为本项目侵犯了您的权益，请联系开发者，我们将立即采取措施进行处理。",
    disclaimerAgree: "使用本网站即表示您已阅读并同意上述条款。",
  },
};
